import { ArrowForwardOutlined } from '@mui/icons-material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BadgeIcon from "@mui/icons-material/Badge";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Alert,
    Checkbox,
    TextField,
    Typography
} from "@mui/material";


import {
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    InputAdornment,
    MenuItem,
    Alert as MuiAlert,
    Snackbar
} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { configUrl } from '../config';
import { getPredictedCollegesCount } from '../services/CollegePredictorServices/aiCollegePredictorService';
import getAllSubscriptionsService from '../services/OwnTestCreationServices/getAllSubscriptionsService';
import WhatsappSubscription from './WhatsappSubscription';

const CollegePredictor = ({ isLoggedIn, handleShowSubcription }) => {

    const navigate = useNavigate();
    const { referralCode } = useParams();
    console.log("referralCode in CollegePredictor:", referralCode);
    // const [price] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([
        "DEF",
        "NT1",
        "NT2",
        "NT3",
        "OBC",
        "OPEN",
        "PWD",
        "SC",
        "SEBC",
        "ST",
        "TFWS",
        "VJ"
    ]);
    const branchOptions = [
        {
            value: "Aeronautical & Automotive",
            label: "Aeronautical & Automotive (All Related Branches)",
            branches: ["Aeronautical & Automotive"],
        },
        {
            value: "Computer",
            label: "Computer (All Related Branches)",
            branches: [
                "Computer",
                "Information Technology",
                "AI & Data Science",
                "Cyber Security & IoT",
            ],
        },
        {
            value: "Electronics & Communication",
            label: "Electronics & Communication (All Related Branches)",
            branches: [
                "Electronics & Communication",
                "Electrical & Electronics",
            ],
        },
        {
            value: "Mechanical",
            label: "Mechanical (All Related Branches)",
            branches: [
                "Mechanical",
                "Mechatronics & Robotics",
            ],
        },
        {
            value: "Civil",
            label: "Civil (All Related Branches)",
            branches: ["Civil"],
        },
    ];

    const locationOptions = [
        {
            value: "Amravati",
            label: "Amravati",
            cities: [
                "Amravati",
                "Badnera"
            ],
        },
        {
            value: "Aurangabad",
            label: "Chh.Sambhajinagar",
            cities: [
                "Aurangabad",
                "Sambhajinagar"
            ],
        },
        {
            value: "Kolhapur",
            label: "Kolhapur",
            cities: [
                "Kolhapur",
                "Gadhinglaj",
                "Ichalkaranji",
                "Panhala",
                "Warananagar"
            ],
        },
        {
            value: "Mumbai",
            label: "Mumbai",
            cities: [
                "Mumbai",
                "Andheri",
            ],
        },
        {
            value: "Navi Mumbai",
            label: "Navi Mumbai",
            cities: ["Navi Mumbai"],
        },
        {
            value: "Nagpur",
            label: "Nagpur",
            cities: [
                "Nagpur",
                "Ramtek"
            ],
        },
        {
            value: "Nashik",
            label: "Nashik",
            cities: [
                "Nashik",
                "Malegaon",
                "Sinnar"
            ],
        },
        {
            value: "Pune",
            label: "Pune",
            cities: [
                "Pune",
                "Baramati",
                "Bhor",
                "Haveli",
                "Indapur",
                "Lonavala",
                "Avasari",
                "Bhima",
                "Dumbarwadi",
                "Lakhewadi",
                "Pisoli",
                "Ravet",
                "Sasewadi",
                "Someshwar Nagar",
                "Talegaon",
                "Vadgaon",
                "Wagholi",
                "Yelgaon"
            ],
        },
        {
            value: "Solapur",
            label: "Solapur",
            cities: [
                "Solapur",
                "Barshi",
                "Pandharpur",
                "Sangola"
            ],
        },
        {
            value: "Sangli",
            label: "Sangli",
            cities: [
                "Sangli",
                "Akluj",
                "Jaysingpur",
                "Miraj"
            ],
        }
    ];
    const [loading, setLoading] = useState(false)

    const [rank, setRank] = useState("");
    const [category, setCategory] = useState("OPEN");
    const [seatType, setSeatType] = useState("All");
    const [preferredBranch, setPreferredBranch] = useState([]);
    const [locationPreference, setLocationPreference] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);

    const opend = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);

    const handleClosed = () => setAnchorEl(null); const [openForm, setOpenForm] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState([]);
    const [severty, setSeverty] = useState('warning');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const [colleges] = useState([
        {
            "College Code": 3012,
            "Branch Code": "301224510",
            "Category": "GOBCS",
            "Branch": "Computer Engineering",
            "City": "Mumbai",
            "College": "Veermata Jijabai Technological Institute(VJTI), Matunga, Mumbai",
            "Highest Rank": 667,
            "Percentile": 99.7498822,
            "Rank": 667,
            "Round": 2,
            "Round 1 Percentile": 99.8171846,
            "Round 1 Rank": 468,
            "Round 2 Percentile": 99.7498822,
            "Round 2 Rank": 667,
            "Stage": "I",
            "SI": 60,
            "Highest Percentile": 99.8171846,
            "AbbreviatedName": "VJTI, Mumbai"
        },
        {
            "College Code": 16006,
            "Branch Code": "1600661210",
            "Category": "GOPENS",
            "Branch": "Mechanical Engineering",
            "City": "Pune",
            "College": "COEP Technological University",
            "Highest Rank": 2044,
            "Percentile": 99.3496503,
            "Rank": 2044,
            "Round": 2,
            "Round 1 Percentile": 99.4352449,
            "Round 1 Rank": 1756,
            "Round 2 Percentile": 99.3496503,
            "Round 2 Rank": 2044,
            "Stage": "I",
            "SI": 150,
            "Highest Percentile": 99.4352449,
            "AbbreviatedName": "COEP, Pune"
        },
        {
            "College Code": 3014,
            "Branch Code": "301461210",
            "Category": "GOPENS",
            "Branch": "Mechanical Engineering",
            "City": "Andheri",
            "College": "Sardar Patel College of Engineering, Andheri",
            "Highest Rank": 3122,
            "Percentile": 99.1923077,
            "Rank": 2612,
            "Round": 2,
            "Round 1 Percentile": 99.0517692,
            "Round 1 Rank": 3122,
            "Round 2 Percentile": 99.1923077,
            "Round 2 Rank": 2612,
            "Stage": "I",
            "SI": 60,
            "Highest Percentile": 99.1923077,
            "AbbreviatedName": "Sardar Patel College, Andheri"
        }
    ])
    const [loadingSignUp, setSignUpLoading] = useState(false);

    // const [subscription, setSubscriptions] = useState([]);
    // console.log(subscription, '-subs in cp')
    // const getAllSubscriptions = async () => {
    //     const subscriptions = await getAllSubscriptionsService();
    //     setSubscriptions(subscriptions);
    // }
    // useEffect(() => {
    //     getAllSubscriptions();
    // }, [])

    // Validation logic

    const getSelectedBranches = () => {
        return [
            ...new Set(
                preferredBranch.flatMap((selected) => {
                    const branch = branchOptions.find((b) => b.value === selected);
                    return branch ? branch.branches : [];
                })
            ),
        ];
    };
    const getSelectedLocations = () => {
        return [
            ...new Set(
                locationPreference.flatMap((selected) => {
                    const location = locationOptions.find((b) => b.value === selected);
                    return location ? location.cities : [];
                })
            ),
        ];
    };
    const validateFields = () => {
        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedMobile = mobile.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[0-9]{10}$/;
        if (!trimmedName) {
            setShowError("Name is required");
            setSeverty("error");
            setOpen(true);
            return false;
        }
        else if (!trimmedEmail) {
            setShowError("Email is required");
            setSeverty("error");
            setOpen(true);
            return false;
        } else if (!emailRegex.test(trimmedEmail)) {
            setShowError("Enter a valid email address");
            setSeverty("error");
            setOpen(true);
            return false;
        }

        if (trimmedMobile && !mobileRegex.test(trimmedMobile)) {
            setShowError("Enter a valid 10-digit mobile number");
            setSeverty("error");
            setOpen(true);
            return false;
        }

        return true;
    };

    const toggleDistrict = (district) => {
        const cities = locationOptions[district];

        const allSelected = cities.every(city =>
            locationPreference.includes(city)
        );

        if (allSelected) {
            setLocationPreference(prev =>
                prev.filter(c => !cities.includes(c))
            );
        } else {
            setLocationPreference(prev => [
                ...new Set([...prev, ...cities])
            ]);
        }
    };

    const toggleCity = (city) => {
        setLocationPreference(prev =>
            prev.includes(city)
                ? prev.filter(c => c !== city)
                : [...prev, city]
        );
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
        setShowError("");
    };
    const onCheckCountValidation = async () => {
        try {
            let preferredBranchs = getSelectedBranches();
            let preferredLocation = getSelectedLocations();
            const collegeCounts = await getPredictedCollegesCount(
                "pcm",
                rank,
                preferredBranchs ?? ["All"],
                category,
                preferredLocation ?? ["All"],
                seatType,
                "All"
            );
            let c = collegeCounts?.count ?? 0;
            return c;
        } catch (error) {
            console.error("Error fetching predicted college count:", error);

            setOpen(true);
            setShowError("Something went wrong.");
            setSeverty("error");

            return 0;
        }
    };
    const onNextHandle = async () => {
        setSignUpLoading(true);
        const subscription = await getAllSubscriptionsService();
        console.log(subscription, '-subs respincp')
        const series = {
            text: "College Predictor",
            subscriptionTypeId: subscription[1]?.subscriptionTypeId,
            courseId: subscription[1]?.subscriptionTypeId ?? 0,
            price: subscription[1]?.price ?? 0,
        };
        let CPFiltersValues = {
            rank,
            preferredBranch,
            locationPreference,
            category
        }
        const ResourceTypeId = 4;
        if (isLoggedIn) {
            setShowCheckout(true);
        } else {
            handleShowSubcription('#college-predictor');
            navigate("/medineer/SignUp", { state: { series, ResourceTypeId, referralCode, CPFiltersValues } });
        }
        setSignUpLoading(false);
    };

    const onPredictClick = async () => {
        console.log("datais", rank, preferredBranch, locationPreference, category)
        let preferredBranchs = getSelectedBranches();
        let preferredLocation = getSelectedLocations();


        if (!rank || !preferredBranchs || !preferredLocation || !category) {
            setOpen(true);
            setShowError("Please fill Rank, Category, Branch, and Location first");
            setSeverty('error');
            setLoading(false);
            return;
        }
        //BSS- was added for validate colleges greater than count.
        let collegeCount = await onCheckCountValidation();
        if (collegeCount < 25) {
            setOpen(true);
            setShowError("Looks like there are only a few matching preferences. Try changing your filters.");
            setSeverty('warning');
            setLoading(false);
            return;
        }

        // Show confirmation first
        setConfirmOpen(true);
        // setOpenModal(true)
    };
    const handleConfirmProceed = () => {
        setConfirmOpen(false);
        setOpenModal(true);
    };
    const handleSubmit = async () => {
        if (validateFields()) {
            let FeatureKey = "college_predictor"
            const payload = {
                "Name": name,
                "Email": email,
                "Mobile": mobile,
                FeatureKey,
                "Percentile": rank,
                "Branch": preferredBranch,
                "City": locationPreference
            };

            try {
                setLoading(true);
                let resp = await axios.post(`${configUrl.AssessmentServer}/api/User/FeatureRecord`, payload);
                if (resp.data?.allowed == true) {
                    setOpen(true);
                    setShowError("Thanks! Please check your email for your personalized college list.");
                    setSeverty('success');
                } else {
                    setOpen(true);
                    setShowError("Oh! Please subscribe to the College Predictor feature to receive updates and alerts throughout the admission process.");
                    setSeverty('warning');
                }
                setLoading(false);
                setOpenForm(false);
                setName(null);
                setMobile(null);
                setEmail(null);
                setRank("")
                setPreferredBranch(null)
                setLocationPreference(null)

            } catch (error) {
                console.error("Error saving data:", error);
                // alert("Something went wrong.");
                setOpen(true);
                setShowError("Something went wrong.");
                setSeverty('error');
                setLoading(false);
            }
        }
    };
    const handleJoinWhatsapp = () => {
        window.open(
            "https://chat.whatsapp.com/GCVRkB4VZK86eFQaK6vyj4?mode=ac_t",
            "_blank"
        );
    };


    // useEffect(() => {
    //     const fetchFilters = async () => {
    //         try {
    //             const response = await axios.get(`${configUrl.PredictorServer}/getFilters`);
    //             const data = response.data;

    //             const uniqueBranches = Array.from(new Set(data?.branches || []));
    //             setBranchOptions(uniqueBranches);
    //             setCityOptions(data?.cities || []);
    //         } catch (error) {
    //             console.error("Error fetching filter options:", error);
    //         }
    //     };
    //     fetchFilters();
    // }, []);
    const ruleColors = [
        "#25d366",
        "#7f5bab",
        "#1b4cb0",
    ];
    return (
        <Box
            id="predictor"
            sx={{
                position: "relative",
                py: { xs: 8, md: 12 },
                bgcolor: "white",
                overflow: "hidden",
            }}
        >
            {/* Background Circles */}
            <Box
                sx={{
                    position: "absolute",
                    top: -100,
                    left: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "secondary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />

            <Box sx={{ position: "relative", zIndex: 2, px: 2, maxWidth: 1200, mx: "auto" }}>
                <Grid container spacing={6}>
                    {/* LEFT SECTION */}
                    <Grid item xs={12} md={6}>

                        {/* Heading */}
                        <Typography
                            sx={{
                                fontSize: "2rem",
                                fontWeight: 700,
                                lineHeight: 1.2,
                                color: "#242e42",
                                mb: 2,
                                textAlign: "left",
                                fontFamily: "inherit",
                            }}
                        >

                            Let's find the right <span style={{ color: '#f08021' }}>Engineering College for you!</span>

                        </Typography>

                        {/* Subtitle */}
                        <Typography
                            sx={{
                                fontSize: "1.8rem",
                                lineHeight: "2rem",
                                color: "#6c7993",
                                mb: 4,
                                textAlign: "left",
                                fontFamily: "inherit",
                            }}
                        >
                            Before generating your personalized preference list, please verify:
                        </Typography>

                        {/* Rules Card */}
                        <Box
                            sx={{
                                bgcolor: "#F8FAFC",
                                border: "1px solid #E2E8F0",
                                borderRadius: 3,
                                p: 3,
                                mt: 5,
                                boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
                            }}
                        >
                            {[
                                {
                                    title: "MHT-CET Rank (State Merit), Seat Type & Category:",
                                    description: "MHT-CET Rank (State Merit), Seat Type and Category cannot be changed later.",
                                },
                                {
                                    title: "Branch & City:",
                                    description:
                                        "Can try up to 3 times. After final attempt, you can download preference list.",
                                },
                                {
                                    title: "Email ID:",
                                    description:
                                        "Ensure it is correct, your preference list will be sent to this email.",
                                },
                            ].map((rule, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        mb: index !== 2 ? 2.5 : 0,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            minWidth: 10,    // 34,
                                            height: 10,      // 34,
                                            borderRadius: "50%",
                                            bgcolor: "#0B3054",  // ruleColors[index],
                                            color: "#0B3054",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: 700,
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {index + 1}
                                    </Box>

                                    <Typography
                                        sx={{
                                            color: "#475569",
                                            fontSize: "1.6rem",
                                            lineHeight: 1.8,
                                            textAlign: "left",
                                        }}
                                    >
                                        <Box component="span" sx={{ fontWeight: 700, color: "#1E293B" }}>
                                            {rule.title}
                                        </Box>{" "}
                                        {rule.description}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>

                        {/* Bottom Note */}
                        {/* <Box
                            sx={{
                                mt: 3,
                                p: 2,
                                borderRadius: 2,
                                bgcolor: "#FFF8E1",
                                border: "1px solid #FFE082",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#8A6D1D",
                                    fontWeight: 600,
                                    fontSize: "1.25rem",
                                    lineHeight: 1.6,
                                    fontFamily: "inherit",
                                }}
                            >
                                ⚠️ Please verify all details carefully before submitting. Incorrect
                                information may result in an inaccurate preference list and cannot
                                be modified later.
                            </Typography>
                        </Box> */}
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5, mb: 2, bgcolor: "secondary.light", px: 2, py: 1, borderRadius: 5, background: '#ECEED1' }}>
                            <EmojiEventsIcon size={20} color="#1976d2" />
                            <Typography fontWeight={600} color="primary.main" fontSize={'1.4rem'}>
                                College Predictor
                            </Typography>
                        </Box>

                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: '4.8rem',
                                textAlign: 'left',
                                fontWeight: 700,
                                mb: 2,
                                lineHeight: 1.2,
                                color: "#242e42",
                            }}
                        >
                            Your Dream{" "}
                            <Box component="span" sx={{ color: "primary.main" }}>
                                Engineering College
                            </Box>{" "}
                            is Closer Than You Think!
                        </Typography>

                        <Typography variant="h6" mb={4} sx={{ fontSize: '2rem', lineHeight: '2.8rem', color: '#6c7993', textAlign: 'left' }}>
                            Smart predictions, real insights & step-by-step guidance to make your admission journey stress-free.
                        </Typography>

                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: { xs: 0.5, sm: 1, md: 1.5 },
                        }}>
                            {[
                                {
                                    icon: <TrendingUpIcon sx={{ color: '#fff', fontSize: '2rem' }} />,
                                    title: "Prepare Better",
                                    desc: "Create the perfect preference list for all CAP rounds.",
                                    bgcolor: '#25d366',
                                    cardbg: '#e8f8ef'
                                },
                                {
                                    icon: <MyLocationIcon sx={{ color: "#fff", fontSize: '2rem' }} />,
                                    title: "Predict Smarter",
                                    desc: "AI-powered predictions based on rank, category & past cut-offs.",
                                    bgcolor: '#7f5bab',
                                    cardbg: '#f3e8ff'
                                },
                                {
                                    icon: <NotificationsActiveIcon sx={{ color: "#fff", fontSize: '2rem' }} />,
                                    title: "Stay Updated",
                                    desc: "Live CAP round updates & alerts on WhatsApp.",
                                    bgcolor: '#1b4cb0',
                                    cardbg: '#e7eff5'
                                },
                                // {
                                //     icon: <AssistantIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                //     title: "Strategic College Planning",
                                //     desc: "Optimize your college admission strategy.",
                                //     bgcolor: '#e7eff5'
                                // },
                                {
                                    icon: <SchoolIcon sx={{ color: "#fff", fontSize: '2rem' }} />,
                                    title: "Admission Simplified",
                                    desc: "One-stop solution for PCM, PCB & MBA aspirants. ",
                                    bgcolor: '#ec9706',
                                    cardbg: '#fff4e5'
                                },
                            ].map((item, i) => (
                                <Box key={i} sx={{
                                    flex: 1,          // Each card gets equal width (25%)
                                    minWidth: 0,
                                    display: "flex",
                                    gap: 0.1,
                                    textAlign: 'center',
                                    backgroundColor: item.cardbg,
                                    borderRadius: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    p: 1.5,
                                }}>
                                    <Box
                                        sx={{
                                            p: 0.75,
                                            borderRadius: "50%",
                                            bgcolor: item.bgcolor, //"grey.100",
                                            height: { xs: 28, sm: 32, md: 36 },
                                            width: { xs: 28, sm: 32, md: 36 },
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            "& svg": {
                                                fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" },
                                            },
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box>
                                        <Typography
                                            fontWeight={600}
                                            sx={{
                                                fontSize: { xs: "0.98rem", sm: "1.3rem", md: "1.8rem" },
                                                color: item?.bgcolor,
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Divider
                                            sx={{
                                                width: "40%",
                                                mx: "auto",           // Centers the divider
                                                my: 1,                // Vertical spacing
                                                borderBottomWidth: 4, // Thickness
                                                borderColor: item.bgcolor,
                                                opacity: 1,
                                            }}
                                        />
                                        <Typography variant="body2" sx={{
                                            fontSize: { xs: "0.65rem", sm: "0.85rem", md: "1.4rem" },
                                            color: "#242e42",
                                            lineHeight: 1.3,
                                            wordBreak: "break-word",
                                        }}>
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                       
                        <Box
                            sx={{
                                mt: 4,
                                p: { xs: 2, md: 2.5 },
                                borderRadius: 3,
                                bgcolor: "#1E3A8A",
                                color: "#fff",
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { xs: "flex-start", sm: "center" },
                                justifyContent: "space-between",
                                gap: 2,
                                boxShadow: "0 10px 25px rgba(30,58,138,0.15)",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: { xs: 1.5, md: 2 },
                                    width: "100%",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: { xs: 48, md: 55 },
                                        height: { xs: 48, md: 55 },
                                        borderRadius: "50%",
                                        bgcolor: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                >
                                    <VerifiedUserIcon
                                        sx={{
                                            color: "#1E3A8A",
                                            fontSize: { xs: 26, md: 30 },
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            textAlign: "left",
                                            fontSize: {
                                                xs: "1rem",
                                                sm: "1.15rem",
                                                md: "1.4rem",
                                            },
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        Trusted by 1000+ Students & Parents
                                    </Typography>

                                    <Typography
                                        sx={{
                                            mt: 0.5,
                                            opacity: 0.9,
                                            textAlign: "left",
                                            fontSize: {
                                                xs: "0.82rem",
                                                sm: "0.9rem",
                                                md: "1.3rem",
                                            },
                                        }}
                                    >
                                        Join thousands of MHT CET aspirants who are already taking smarter admission decisions.
                                    </Typography>
                                </Box>
                            </Box>

                            <AvatarGroup
                                max={4}
                                sx={{
                                    alignSelf: { xs: "flex-end", sm: "center" },
                                    "& .MuiAvatar-root": {
                                        width: { xs: 32, md: 38 },
                                        height: { xs: 32, md: 38 },
                                        fontSize: { xs: 12, md: 14 },
                                    },
                                }}
                            >
                                <Avatar src={Parent1} />
                                <Avatar src={Parent2} />
                                <Avatar src={Parent3} />
                                <Avatar sx={{ bgcolor: "#FFD54F", color: "#000", fontWeight: 700 }}>
                                    1K+
                                </Avatar>
                            </AvatarGroup>
                        </Box>

                        
                        <Box
                            sx={{
                                mt: 2,
                                p: { xs: 2, md: 2.5 },
                                borderRadius: 3,
                                bgcolor: "#F2FBF4",
                                border: "1px solid #D8F0DD",
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { xs: "flex-start", sm: "center" },
                                justifyContent: "space-between",
                                gap: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: { xs: 1.5, md: 2 },
                                    width: "100%",
                                }}
                            >
                                <Avatar
                                    sx={{
                                        bgcolor: "#0e9f43",
                                        width: { xs: 50, md: 58 },
                                        height: { xs: 50, md: 58 },
                                        flexShrink: 0,
                                    }}
                                >
                                    <WhatsAppIcon
                                        sx={{
                                            fontSize: { xs: 28, md: 34 },
                                        }}
                                    />
                                </Avatar>

                                <Box>
                                    <Chip
                                        label="Recommended"
                                        size="small"
                                        sx={{
                                            bgcolor: "#D8F5DE",
                                            color: "#2E7D32",
                                            fontWeight: 600,
                                            mb: 1,
                                            fontSize: { xs: "0.7rem", md: "0.8rem" },
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            color: "#1F2937",
                                            textAlign: "left",
                                            fontSize: {
                                                xs: "1rem",
                                                sm: "1.15rem",
                                                md: "1.35rem",
                                            },
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        Get CAP Round Updates on WhatsApp
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#6B7280",
                                            mt: 0.5,
                                            textAlign: "left",
                                            fontSize: {
                                                xs: "0.82rem",
                                                sm: "0.9rem",
                                                md: "1.3rem",
                                            },
                                        }}
                                    >
                                        Never miss important updates, cut-offs & deadlines.
                                    </Typography>
                                </Box>
                            </Box>

                            <Button
                                variant="contained"
                                startIcon={<WhatsAppIcon />}
                                onClick={handleJoinWhatsapp}
                                sx={{
                                    bgcolor: "#0e9f43",
                                    "&:hover": {
                                        bgcolor: "#0e9f43",
                                    },
                                    color: "#fff",
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 700,
                                    width: {
                                        xs: "100%",
                                        sm: "auto",
                                    },
                                    minWidth: {
                                        sm: 170,
                                    },
                                    py: 1.3,
                                    px: 3,
                                    fontSize: {
                                        xs: "0.95rem",
                                        md: "1rem",
                                    },
                                }}
                            >
                                Join Now
                            </Button>
                        </Box>
                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<SchoolIcon />}
                            sx={{
                                mt: 4,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: '1.4rem',
                                background: 'linear-gradient(135deg, hsl(45 100% 60%), hsl(18 90% 58%))',
                                color: '#fff',
                                float: 'left'
                            }}
                            onClick={onNextHandle}
                        >
                            {loadingSignUp ? 'Loading...' : 'Get College Predictor @ ₹1000'}
                        </Button>
                    </Grid> */}

                    {/* RIGHT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="h4" sx={{
                            textAlign: 'center',
                            fontSize: {
                                xs: '2.8rem', // mobile
                                sm: '2.8rem', // tablet and above (including web)
                            },
                            fontWeight: 600, color: '#242e42'
                        }}>
                            {/* Let's find the right <span style={{ color: '#f08021' }}>Engineering College for you!</span> */}
                            Get Your <span style={{ color: '#f08021' }}>Personalized Preference List!</span>
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2, textAlign: 'center', fontSize: '1.8rem', fontWeight: 400, color: '#242e42' }}>
                            {/* Answer simple questions and get personalised college predictions in seconds. */}
                        </Typography>
                        <Card elevation={4} sx={{ borderRadius: 3 }}>
                            <CardContent sx={{ p: 4 }}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>

                                    {/* Expected Rank */}
                                    <Grid container spacing={2}>
                                        {/* Rank */}
                                        <Grid item xs={12} sm={6}>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        mb: 1,
                                                        textAlign: "left",
                                                        fontSize: "1.4rem",
                                                        fontWeight: 500,
                                                        color: "#242e42",
                                                    }}
                                                >
                                                    MHT-CET Rank (State Merit)
                                                </Typography>

                                                <TextField
                                                    fullWidth
                                                    placeholder="Your MHT-CET state rank"
                                                    value={rank}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "") {
                                                            setRank("");
                                                            return;
                                                        }
                                                        const num = parseInt(value);
                                                        if (!isNaN(num) && num >= 0) {
                                                            setRank(value);
                                                        }
                                                    }}
                                                    InputProps={{
                                                        sx: {
                                                            "& input": {
                                                                fontSize: "1.4rem",
                                                            },
                                                        },
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Box
                                                                    sx={{
                                                                        width: 34,
                                                                        height: 34,
                                                                        borderRadius: 2,
                                                                        bgcolor: "#E8F0FE",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    <TrendingUpIcon
                                                                        sx={{
                                                                            color: "#1447ad",
                                                                            fontSize: "1.7rem",
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        </Grid>

                                        {/* Seat Type */}
                                        <Grid item xs={12} sm={6}>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        mb: 1,
                                                        textAlign: "left",
                                                        fontSize: "1.4rem",
                                                        fontWeight: 500,
                                                        color: "#242e42",
                                                    }}
                                                >
                                                    Seat Type
                                                </Typography>

                                                <TextField
                                                    select
                                                    fullWidth
                                                    value={seatType}
                                                    onChange={(e) => setSeatType(e.target.value)}
                                                    SelectProps={{
                                                        MenuProps: {
                                                            PaperProps: {
                                                                sx: {
                                                                    "& .MuiMenuItem-root": {
                                                                        fontSize: "1.4rem",
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    }}
                                                    sx={{
                                                        bgcolor: "grey.50", borderRadius: 2, "& .MuiSelect-select": {
                                                            fontSize: "1.4rem",
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="All">All</MenuItem>
                                                    <MenuItem value="general">General</MenuItem>
                                                    <MenuItem value="ladies">Ladies</MenuItem>
                                                </TextField>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        mb: 1,
                                                        textAlign: "left",
                                                        fontSize: "1.4rem",
                                                        fontWeight: 500,
                                                        color: "#242e42",
                                                    }}
                                                >
                                                    Category
                                                </Typography>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    value={category}
                                                    onChange={(e) => {
                                                        console.log("calues", e.target);
                                                        setCategory(e.target.value)
                                                    }}
                                                    SelectProps={{
                                                        MenuProps: {
                                                            PaperProps: {
                                                                sx: {
                                                                    "& .MuiMenuItem-root": {
                                                                        fontSize: "1.4rem",
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    }}
                                                    sx={{
                                                        bgcolor: "grey.50", borderRadius: 2, "& .MuiSelect-select": {
                                                            fontSize: "1.4rem",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Box
                                                                    sx={{
                                                                        width: 34,
                                                                        height: 34,
                                                                        borderRadius: 2,
                                                                        bgcolor: "#F3E8FF",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    <BadgeIcon
                                                                        sx={{
                                                                            color: "#7C3AED",
                                                                            fontSize: "1.7rem",
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                >
                                                    {categoryOptions?.map((cat) => (
                                                        <MenuItem key={cat} value={cat}>
                                                            {cat}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            {/* Preferred Branch Dropdown */}
                                            <Box>
                                                <Typography variant="body2"
                                                    sx={{
                                                        mb: 1,
                                                        textAlign: 'left',
                                                        fontSize: '1.4rem',
                                                        fontWeight: 500,
                                                        color: '#242e42'
                                                    }}>
                                                    Preferred Branches
                                                </Typography>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    SelectProps={{
                                                        multiple: true,
                                                        renderValue: (selected) => selected.join(", "),
                                                        MenuProps: {
                                                            PaperProps: {
                                                                sx: {
                                                                    "& .MuiMenuItem-root": {
                                                                        fontSize: "1.4rem",
                                                                    },
                                                                },
                                                            },
                                                        },
                                                    }}
                                                    value={preferredBranch}
                                                    onChange={(e) => setPreferredBranch(e.target.value)}
                                                    sx={{
                                                        bgcolor: "grey.50", borderRadius: 2, "& .MuiSelect-select": {
                                                            fontSize: "1.4rem",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Box
                                                                    sx={{
                                                                        width: 34,
                                                                        height: 34,
                                                                        borderRadius: 2,
                                                                        bgcolor: "#F3E8FF",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    <AccountTreeIcon
                                                                        sx={{
                                                                            color: "#7C3AED",
                                                                            fontSize: "1.7rem",
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                >
                                                    {branchOptions?.map((branch) => (
                                                        <MenuItem key={branch.value} value={branch.value}>
                                                            <Checkbox checked={preferredBranch.indexOf(branch.value) > -1} />
                                                            <ListItemText primary={branch.label} />
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    {/* Location Preference Dropdown */}
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mb: 1,
                                                textAlign: "left",
                                                fontSize: "1.4rem",
                                                fontWeight: 500,
                                                color: "#242e42",
                                            }}
                                        >
                                            City Preference
                                        </Typography>
                                        <TextField
                                            select
                                            fullWidth
                                            value={locationPreference}
                                            onChange={(e) => setLocationPreference(e.target.value)}
                                            SelectProps={{
                                                multiple: true,
                                                renderValue: (selected) => selected.join(", "),
                                                MenuProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            "& .MuiMenuItem-root": {
                                                                fontSize: "1.4rem",
                                                            },
                                                        },
                                                    },
                                                },
                                            }}
                                            sx={{
                                                bgcolor: "grey.50", borderRadius: 2, "& .MuiSelect-select": {
                                                    fontSize: "1.4rem",
                                                },
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Box
                                                            sx={{
                                                                width: 34,
                                                                height: 34,
                                                                borderRadius: 2,
                                                                bgcolor: "#F3E8FF",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <LocationOnIcon
                                                                sx={{
                                                                    color: "#7C3AED",
                                                                    fontSize: "1.7rem",
                                                                }}
                                                            />
                                                        </Box>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        >
                                            {locationOptions.map((city) => (
                                                <MenuItem key={city.value} value={city.value}>
                                                    <Checkbox checked={locationPreference.includes(city.value)} />
                                                    <ListItemText primary={city.label} />
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {/* <TextField
                                            fullWidth
                                            value={locationPreference.join(", ")}
                                            placeholder="Select Locations"
                                            onClick={handleOpen}
                                            InputProps={{
                                                readOnly: true,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LocationOnIcon color="success" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />

                                        <Popover
                                            open={opend}
                                            anchorEl={anchorEl}
                                            onClose={handleClosed}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left"
                                            }}
                                            PaperProps={{
                                                sx: {
                                                    width: 420,
                                                    maxHeight: 500,
                                                    overflowY: "auto",
                                                    mt: 1
                                                }
                                            }}
                                        >
                                            {Object.entries(cityHierarchy).map(([district, cities]) => {

                                                const selectedCount = cities.filter(city =>
                                                    locationPreference.includes(city)
                                                ).length;

                                                const allSelected = selectedCount === cities.length;

                                                const indeterminate =
                                                    selectedCount > 0 &&
                                                    selectedCount < cities.length;

                                                return (
                                                    <Accordion
                                                        key={district}
                                                        disableGutters
                                                        elevation={0}
                                                    >
                                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>

                                                            <FormControlLabel
                                                                onClick={(e) => e.stopPropagation()}
                                                                onFocus={(e) => e.stopPropagation()}
                                                                control={
                                                                    <Checkbox
                                                                        checked={allSelected}
                                                                        indeterminate={indeterminate}
                                                                        onChange={() =>
                                                                            toggleDistrict(district)
                                                                        }
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography fontWeight={600}>
                                                                        {district}
                                                                    </Typography>
                                                                }
                                                            />

                                                        </AccordionSummary>

                                                        <AccordionDetails sx={{ pt: 0 }}>
                                                            <List dense>

                                                                {cities.map(city => (
                                                                    <ListItem key={city} sx={{ pl: 3 }}>

                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={locationPreference.includes(city)}
                                                                                    onChange={() =>
                                                                                        toggleCity(city)
                                                                                    }
                                                                                />
                                                                            }
                                                                            label={city}
                                                                        />

                                                                    </ListItem>
                                                                ))}

                                                            </List>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                );
                                            })}
                                        </Popover> */}
                                    </Box>
                                    <Box sx={{ textAlign: 'left', alignItems: 'left', color: '#e80606', fontWeight: 600, fontSize: '1.6rem' }}>
                                        <small>Note: MHT-CET Rank (State Merit), Seat Type and Category cannot be changed later.</small>
                                    </Box>
                                    <Divider sx={{ color: '#242e42', borderColor: '#242e42' }} />

                                    {/* <Typography variant="subtitle2" sx={{ color: '#6c7993', textAlign: 'left', fontSize: '1.4rem' }}>
                                        Predicted Colleges:
                                    </Typography>

                                    {colleges.map((college, index) => (
                                        <Col key={index}>
                                            <Card style={{ backgroundColor: '#ffff', margin: '0px' }} className='card'>
                                                <div className='floatingHeadWait'>
                                                    <div>{college.Category}</div>
                                                    <div>{college["Highest Rank"]}</div>
                                                    <div className="percentileText">
                                                        {`${parseFloat(college["Highest Percentile"]).toFixed(2)}`}
                                                    </div>

                                                </div>
                                                <div>
                                                    <h4 className='notificationTextTitle'>
                                                        {`${college?.AbbreviatedName || college?.College} (${college["College Code"]})`}
                                                        <Tooltip
                                                            title={college.College}
                                                            color="blue"
                                                            trigger="click"
                                                        >
                                                            <div className="info-icon">
                                                                <InfoCircleOutlined />
                                                            </div>
                                                        </Tooltip>
                                                    </h4>
                                                    <h5 className="notificationText">
                                                        {college.Branch}{` (${college["Branch Code"]})`}&nbsp;
                                                    </h5>
                                                    <h5 className="notificationText" style={{ marginTop: 5 }}>
                                                        {`Overall Seats: ${college["SI"]}`}&nbsp;
                                                    </h5>
                                                </div>

                                            </Card>
                                        </Col>
                                    ))} */}

                                    {/* {[1, 2, 3].map((i) => (
                                        <Box
                                            key={i}
                                            sx={{
                                                display: "flex",
                                                gap: 2,
                                                alignItems: "center",
                                                p: 2,
                                                borderRadius: 2,
                                                border: "1px solid",
                                                borderColor: "#d7e7ea",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    bgcolor: "#0B3054",
                                                    color: "white",
                                                    fontWeight: 700,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {i}
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ height: 10, bgcolor: "grey.200", borderRadius: 1, width: "75%", mb: 1 }} />
                                                <Box sx={{ height: 8, bgcolor: "grey.300", borderRadius: 1, width: "50%" }} />
                                            </Box>
                                        </Box>
                                    ))} */}
                                    <Button
                                        variant="contained"
                                        size="large"
                                        endIcon={<ArrowForwardOutlined />}
                                        sx={{
                                            // mt: 4,
                                            borderRadius: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            fontSize: '1.4rem',
                                            background: '#0B3054', // 'linear-gradient(135deg, hsl(45 100% 60%), hsl(18 90% 58%))',
                                            color: '#fff',
                                            float: 'left'
                                        }}
                                        onClick={onPredictClick}
                                    >
                                        {loadingSignUp ? 'Loading...' : `✨ Get preference list @ ₹ 500`}
                                    </Button>
                                    {/* <small><VerifiedUserIcon sx={{ color: '#1c02ad' }} /> 100% Safe & Secure • No Login Required </small> */}
                                    {/* <Button
                                        fullWidth
                                        variant="contained"
                                        size="large"
                                        sx={{
                                            mt: 2,
                                            borderRadius: 3,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            padding: '1.2rem 2.2rem',
                                            fontSize: '1.4rem',
                                            color: '#fff',
                                            background: '#0B3054',
                                        }}
                                        onClick={onPredictClick}
                                    >
                                        Predict My Colleges
                                    </Button> */}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={5000}>
                <MuiAlert
                    severity={severty} //"error"
                    onClose={handleClose}
                    sx={{
                        width: "100%",
                        fontSize: "15px",
                        ...(severty === "error" && {
                            backgroundColor: "#d32f2f",
                            color: "#fff",
                        }),
                        ...(severty === "warning" && {
                            backgroundColor: "#ed6c02",
                            color: "#fff",
                        }),
                        ...(severty === "success" && {
                            backgroundColor: "#2e7d32",
                            color: "#fff",
                        }),
                        ...(severty === "info" && {
                            backgroundColor: "#0288d1",
                            color: "#fff",
                        }),
                    }}
                >
                    {showError}
                </MuiAlert>
            </Snackbar>
            <WhatsappSubscription
                open={openModal}
                onClose={() => setOpenModal(false)}
                title="Enter Your Details"
                price={500}
                type={"preferencelist"}
                CPFiltersValues={{
                    rank,
                    preferredBranch: getSelectedBranches(),
                    locationPreference: getSelectedLocations(),
                    category,
                    genderType: seatType,
                }}
            />

            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        fontFamily:
                            'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        backgroundColor: "#0B3054", // dark blue
                        color: "#fff",
                        textAlign: "left",
                        py: 2,
                        display: 'inline-flex',
                        alignItem: 'center'
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))', // orange background
                            borderRadius: 2,
                            width: 42,
                            height: 42,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: '1rem'
                        }}
                    >
                        <MailOutlineIcon sx={{ color: "#0B3054", fontSize: '2.5rem' }} />
                    </Box>
                    <Box>
                        Get Your College List
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    {/* Subtext */}
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 2,
                            textAlign: "left",
                            fontSize: "2rem",
                            color: "#4a4a4a",
                            fontWeight: '600',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        }}
                    >
                        Get your college list by email—just fill in your details.
                    </Typography>
                    <TextField
                        label="Name"
                        fullWidth
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.2rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Email"
                        type="email"
                        required
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.2rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Mobile"
                        fullWidth
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.2rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button
                        onClick={() => setOpenForm(false)}
                        variant="outlined"
                        // sx={{ textTransform: "none" }}
                        // variant="contained"
                        size="large"
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            border: '1px solid #0B3054',
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#0B3054',
                            // background: '#0B3054',
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        disabled={loading}
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#fff',
                            background: '#0B3054',
                            '&:disabled': { backgroundColor: '#0B3054a1' }
                        }}
                        onClick={() => handleSubmit()}
                    >
                        {loading ? 'Loading...' :
                            "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle
                    sx={{
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        // backgroundColor: "#0B3054",
                        color: "#0B3054",
                        textAlign: "left",
                        py: 2,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            background:
                                "linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))",
                            borderRadius: 2,
                            width: 42,
                            height: 42,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: 2,
                        }}
                    >
                        <WarningIcon
                            sx={{ color: "#0B3054", fontSize: "2.5rem" }}
                        />
                    </Box>

                    Confirm Your Details
                </DialogTitle>

                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mt: 2,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "2rem",
                            fontWeight: 600,
                            color: "#242e42",
                        }}
                    >
                        Please verify these details before continuing.
                    </Typography>

                    <Box
                        sx={{
                            border: "1px solid #E5E7EB",
                            borderRadius: 3,
                            p: 2.5,
                            background: "#F8F9FB",
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Typography
                                    sx={{
                                        fontSize: "1.3rem",
                                        color: "#6B7280",
                                        fontWeight: 600,
                                    }}
                                >
                                    Rank
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "1.6rem",
                                        fontWeight: 700,
                                        color: "#0B3054",
                                    }}
                                >
                                    {rank}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography
                                    sx={{
                                        fontSize: "1.3rem",
                                        color: "#6B7280",
                                        fontWeight: 600,
                                    }}
                                >
                                    Seat Type
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "1.6rem",
                                        fontWeight: 700,
                                        color: "#0B3054",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    {seatType}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography
                                    sx={{
                                        fontSize: "1.3rem",
                                        color: "#6B7280",
                                        fontWeight: 600,
                                    }}
                                >
                                    Category
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "1.6rem",
                                        fontWeight: 700,
                                        color: "#0B3054",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    {category}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Alert
                        severity="warning"
                        sx={{
                            borderRadius: 2,
                            fontSize: "1.35rem",
                            alignItems: "center",
                        }}
                    >
                        <Typography sx={{ fontSize: "1.35rem" }}>
                            After you continue, <strong>Rank, Seat Type, and Category</strong> cannot be changed. <strong>Branch and City choices</strong> can still be changed later.
                        </Typography>
                    </Alert>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center' }}>
                    <Button
                        onClick={() => setConfirmOpen(false)}
                        variant="outlined"
                        size="large"
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            border: "1px solid #0B3054",
                            textTransform: "none",
                            fontWeight: 600,
                            padding: "0.75rem 2rem",
                            fontSize: "1.4rem",
                            color: "#0B3054",
                        }}
                    >
                        Back
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleConfirmProceed}
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            textTransform: "none",
                            fontWeight: 600,
                            padding: "0.75rem 2rem",
                            fontSize: "1.4rem",
                            color: "#fff",
                            background: "#0B3054",
                            "&:hover": {
                                background: "#092742",
                            },
                        }}
                    >
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
        </Box >
    );
};
export default CollegePredictor;
